<template>
  <resource-show-wrapper :title="'View Number'">
    <v-card>
      <v-card-title>{{ $t("resources.phone_numbers.show.details") }}</v-card-title>
      <v-card-subtitle>{{ $t("resources.phone_numbers.show.subtitle") }}</v-card-subtitle>
      <div class="phone-number__wrapper">
        <div v-if="item.domain">
          <div class="d-flex align-center">
            <span class="phone-number__label">{{ $t("resources.phone_numbers.show.domain") }}</span>
          </div>
          <span class="phone-number__value">{{ item.domain.name }}</span>
        </div>
        <div v-if="item.number">
          <div class="d-flex align-center">
            <span class="phone-number__label">{{ $t("resources.phone_numbers.show.number") }}</span>
            <CopyText display-icon :value="item.number"></CopyText>
          </div>
          <span class="phone-number__value">{{ item.number }}</span>
        </div>
        <div v-if="item.publisherName">
          <div class="d-flex align-center">
            <span class="phone-number__label">{{ $t("resources.phone_numbers.show.publisher_name") }}</span>
          </div>
          <span class="phone-number__value">{{ item.publisherName }}</span>
        </div>
        <div v-if="item.publisherSubId">
          <div class="d-flex align-center">
            <span class="phone-number__label">{{ $t("resources.phone_numbers.show.publisher_sub_id") }}</span>
          </div>
          <span class="phone-number__value">{{ item.publisherSubId }}</span>
        </div>
        <div v-if="item.campaignName">
          <div class="d-flex align-center">
            <span class="phone-number__label">{{ $t("resources.phone_numbers.show.campaign_name") }}</span>
          </div>
          <span class="phone-number__value">{{ item.campaignName }}</span>
        </div>
        <div v-if="item.campaignId">
          <div class="d-flex align-center">
            <span class="phone-number__label">{{ $t("resources.phone_numbers.show.campaign_id") }}</span>
          </div>
          <span class="phone-number__value">{{ item.campaignId }}</span>
        </div>
        <div v-if="item.script">
          <div class="d-flex align-center">
            <span class="phone-number__label">{{ $t("resources.phone_numbers.show.campaign_script") }}</span>
            <CopyText display-icon :value="item.script"></CopyText>
          </div>
          <v-text-field class="pt-0" :value="item.script" hide-details="auto" disabled></v-text-field>
        </div>
        <div v-if="item.jsTagId">
          <div class="d-flex align-center">
            <span class="phone-number__label">{{ $t("resources.phone_numbers.show.js_tag") }}</span>
            <CopyText display-icon :value="item.jsTagId"></CopyText>
          </div>
          <v-text-field class="pt-0" :value="item.jsTagId" hide-details="auto" disabled></v-text-field>
        </div>
      </div>
    </v-card>
  </resource-show-wrapper>
</template>

<script>
  import ResourceShowWrapper from "@/components/resourceWrappers/ResourceShowWrapper";
  import CopyText from "@/components/custom/CopyText";

  export default {
    components: {
      ResourceShowWrapper,
      CopyText,
    },
    props: {
      /** Injected by VA-admin */
      item: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    beforeMount() {
      if (this.item?.errorMessage) {
        this.$admin.toast.error(this.item?.errorMessage);
      }
    },
  };
</script>

<style scoped lang="scss">
  @import "../../@core/preset/preset/typography/index.scss";
  @import "../../@core/preset/preset/functions.scss";
  .phone-number {
    &__wrapper {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
    &__label {
      @include text-caption-bold();
      color: get-color("subtitle");
    }
    &__value {
      @include text-body-2();
      color: get-color("subtitle");
    }
  }
</style>
